import React, { useEffect, useState } from 'react';
import { useFormContext } from 'react-hook-form';
import { connect, useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { useParams } from 'react-router-dom';



import Loading from 'components/base/Loading';



import { SaveAndBackButtons } from '../../../components/base/BottomStepComponent';
import ContentSections from '../../../components/base/ContentSections';
import DeletePrompt from '../../../components/base/DeletePrompt';
import BasePrompt from '../../../components/base/prompt/BasePrompt';
import CreateStoreStepOneContentSection from '../../../components/store/CreateStoreStepOneContentSection';
import { defaultPreviewImage, getPreviewLayoutImages } from '../../../components/store/StorePreviewConfig';
import { APIStatus, CheckStatus, // LanguageConfig,
DELETE_RELATED_SECTIONS } from '../../../config/CustomEnums';
import { PermissionCodes } from '../../../config/PermissionCodes';
import { createAction } from '../../../utils';


function CreateStoreStepOne({ store, checked, saved, languages }) {
  const history = useHistory();
  const dispatch = useDispatch();
  const params = useParams();
  const { watch, getValues, trigger } = useFormContext();
  const watchIsOnlineStore = watch('isOnlineStore');

  const inputWithImageConfig = getPreviewLayoutImages();
  const [showDeletePrompt, setShowDeletePrompt] = useState(false);
  const [activeSection, setActiveSection] = useState();
  const [showAlertPrompt, setShowAlertPrompt] = useState({
    title: 'brand',
    show: false,
    pathname: 'brand/create',
  });
  const [refreshDate, setRefreshDate] = useState(new Date());

  useEffect(() => {
    dispatch(createAction('language/getList')({ isSelectorLoad: true }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch]);

  useEffect(() => {
    if (checked === CheckStatus.checkedWithSuccess) {
      dispatch(createAction('storeModel/createOrUpdate')({}));
    }
  }, [dispatch, checked]);

  useEffect(() => {
    if (
      saved === APIStatus.success &&
      history.location.pathname.includes('edit')
    ) {
      history.push('/stores');
    }
  }, [history, saved]);

  useEffect(() => {
    return () => {
      dispatch({ type: 'storeModel/clearData' });
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const id = params.id;
  useEffect(() => {
    if (id) {
      dispatch(createAction('storeModel/getOneStore')({ id }));
    } else {
      dispatch({ type: 'storeModel/loadDataFromCookie' });
    }

    dispatch(createAction('storeModel/getDistrictList')({}));
    dispatch(createAction('storeCategoryList/getAllStoreSubcategoryList')({}));
    dispatch({
      type: 'mall/getPagedMallList',
      payload: {
        isSelectorLoad: true
      },
    });
  }, [dispatch, id, refreshDate]);

  // const getLanguageTab = (language) => {
  //   return [
  //     [
  //       <CreateStoreStepOneContentSection language={language} onFocus={setActiveSection} setShowAlertPrompt={setShowAlertPrompt}/>
  //     ],
  //   ];
  // };

  // const languageTabConfig = {
  //   enContainer: getLanguageTab(LanguageConfig.english),
  //   hantContainer: getLanguageTab(LanguageConfig.traditionalChinese),
  //   hansContainer: getLanguageTab(LanguageConfig.simplifiedChinese),
  // };

  const getTabs = (language, setActiveSection) => {
    const tabs = [
      <CreateStoreStepOneContentSection
        language={language}
        onFocus={setActiveSection}
        setShowAlertPrompt={setShowAlertPrompt}
        refreshDate={refreshDate}
      />,
    ];
    return tabs;
  };

  if (saved === APIStatus.calling) {
    return <Loading />;
  }

  return (
    <>
      <ContentSections
        languageTabContent={{
          containers: languages?.map((item) => ({
            container: getTabs(item.code, setActiveSection),
            key: item.code,
            title: item.sourceName,
          })),
        }}
        inputWithImageConfig={inputWithImageConfig}
        defaultImage={defaultPreviewImage()}
        activeSection={activeSection}
        hidePreview={watchIsOnlineStore}
      />
      <SaveAndBackButtons
        saveTempText={params.id ? 'Delete' : null}
        saveText={params.id ? 'Update' : 'Save'}
        backAction={() => history.goBack()}
        saveAction={async () => {
          let isValid = await trigger(
            [
              'storeTranslations.en.name',
              'displayPriority',
              'coverPhoto',
              'storeTranslations.en.address',
              'emailAddress',
              'storeTranslations.en.description',
              'subcategories',
              'selectedSubcategories',
              'latitude',
              'longitude',
              'staffCode',
            ],
            { shouldFocus: true },
          );
          console.log('@83', isValid, getValues(), isValid);
          if (isValid) {
            dispatch(
              createAction('storeModel/createOrUpdate')({
                data: getValues(),
                afterActions: () => history.push({ pathname: '/stores' }),
              }),
            );
          }
          // dispatch({ type: 'storeModel/checkValsValid' });
        }}
        saveTempAction={() => setShowDeletePrompt(true)}
        tempRequires={PermissionCodes.deleteStore}
      />
      <DeletePrompt
        message={{
          title: 'Delete this Store',
          content: 'Did you confirm to delete this Store?',
        }}
        title={'Store'}
        data={store}
        relatedSections={DELETE_RELATED_SECTIONS.STORE}
        show={showDeletePrompt}
        onClose={() => {
          setShowDeletePrompt(false);
        }}
        onConfirm={() => {
          setShowDeletePrompt(false);
          dispatch({
            type: `storeModel/updateState`,
            payload: { checkedList: [store] },
          });
          dispatch(
            createAction('storeModel/delete')({
              afterAction: () => {
                history.push('/stores');
              },
            }),
          );
        }}
      />
      <BasePrompt
        show={showAlertPrompt.show}
        closeAction={() =>
          setShowAlertPrompt({ ...showAlertPrompt, show: false })
        }
        leftButton={{
          text: 'Done and refresh',
          action: () => {
            setRefreshDate(new Date());
            setShowAlertPrompt({ ...showAlertPrompt, show: false });
          },
        }}
        rightButton={{
          text: `Go to create ${showAlertPrompt.title}`,
          action: () => {
            window.open(showAlertPrompt.pathname, '_blank');
          },
        }}
        title={`Go to create a ${showAlertPrompt.title}?`}
        description={`You will leave the store creation process. After you create a new ${showAlertPrompt.title}, you can back to this page.`}
      />
    </>
  );
}

const mapPropsToState = (state) => ({
  store: state.storeModel.oneStore || {},
  checked: state.storeModel.checked,
  errorFields: state.storeModel.errorFields,
  saved: state.storeModel.saved,
  languages: state.language.allList,
  // districtList: state.storeModel.districtList,
  // subCategoryList: state.storeCategoryList.subCategoryList,
  // formChanged: state.storeModel.formChanged,
});

export default connect(mapPropsToState)(CreateStoreStepOne);